import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  padding: 20px 0 20px 25px;
  display: flex;
  flex-direction: column;

  position: relative;
`;
export const Span1 = styled.span`
  color: #000000;
  font-size: 18px;
  font-family: inherit;
  font-weight: 700;
`;
export const Span2 = styled.span`
  font-size: 15px;
  font-family: inherit;
  font-weight: 400;
  color: #2a2929;
  margin: 8px 0;
  word-break: break-word;
`;

export const StyledContainer = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
`;
export const ChannelsText = styled.div`
  display: flex;
  font-size: 15px;
  color: #2a2929;
  font-size: 15px;
  font-weight: 500;
  margin-right: 8px;
  font-family: inherit;
`;

export const TwitterText = styled.p`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #2a2929;
  margin: 0;

  & svg {
    width: 20px;
    height: 25px;
    padding-top: 0px;
  }
`;
export const Icon = styled.div``;

export const FlexForLogoDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
`;
export const InstagramImgDiv = styled.div`
  width: ${(props) => (props?.whithVal ? '60px' : '70px')};
  height: ${(props) => (props?.whithVal ? '60px' : '70px')};
  border-radius: 50%;
  // border:${(props) =>
    props.searchType == 'user' ? 'none' : '1px solid gray'};
`;
export const H3TitleForInsta = styled.div`
  margin: 0px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-family: inherit;
  color: #2a2929;
`;

export const PTitleforInsta = styled.div`
  margin: 0px;
  margin-left: 20px;
  color: #2a2929;
  font-size: 15px;
  font-weight: 400;
  font-family: inherit;
`;
export const QueryPara = styled.div`
  color: #2a2929;
  font-size: 14px;
  margin-top: 10px;
  font-family: inherit;
  font-weight: 400;

  & > b {
  font-family: inherit;
    font-weight: 500;
  }
`;

export const CreateTopic = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;

  display: flex;
  align-items: center;
  gap: 10px;

  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  // background: #353cf7;
  background: linear-gradient(95.02deg, #a0d925 -65.35%, #006a68 100%);
  color: #fff;

  padding: 10px 20px;
  border-radius: 10px;
  font-family: inherit;

  border: 0px;

  &:active {
    transform: scale(0.98);
  }
`;

export const EditTopic = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 107px;
  height: 44px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  background: #fff;
  color: #2a886b;
  border-radius: 10px;
  font-family: inherit;
  border: 1px solid #2a886b;

  &:active {
    transform: scale(0.98);
  }
`;